/**
 * Route Dependencies
 */
const DashboardIndex = r => require.ensure([], () => r(require('../components/views/DashboardIndex')), 'dashboard')

/**
 * Dashboard Routes
 */
export default {
    path: '',
    name: 'dashboard',
    component: DashboardIndex
}



// WEBPACK FOOTER //
// ./src/router/dashboard.js